export function analyticsTrack(event) {
    // so not to break server rendering
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    }
}
//# sourceMappingURL=analytics-utils.js.map